module.exports = __webpack_public_path__ + "03ac4c0d5fa7007aeb1402928ec57c13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/send-rates.svg
// module id = 2819
// module chunks = 1